import React from 'react'

export default function RankingIcon({ fillcolor, onClick, ...props }) {
  return (
    <svg
      fill={fillcolor || 'currentColor'}
      {...props}
      viewBox="0 0 23 18"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}>
      <path d="M12.6666 13.938V16H17.6666V18H5.66663V16H10.6666V13.938C8.73333 13.6942 6.95545 12.7533 5.66663 11.2917C4.37781 9.83023 3.66666 7.94861 3.66663 6V0H19.6666V6C19.6666 7.94861 18.9554 9.83023 17.6666 11.2917C16.3778 12.7533 14.5999 13.6942 12.6666 13.938ZM5.66663 2V6C5.66663 7.5913 6.29877 9.11742 7.42399 10.2426C8.5492 11.3679 10.0753 12 11.6666 12C13.2579 12 14.784 11.3679 15.9093 10.2426C17.0345 9.11742 17.6666 7.5913 17.6666 6V2H5.66663ZM0.666626 2H2.66663V6H0.666626V2ZM20.6666 2H22.6666V6H20.6666V2Z" />
    </svg>
  )
}
